<mat-expansion-panel class="expansion-panel" [expanded]="step === 1" (opened)="setStep(1)">

  <mat-expansion-panel-header class="custom-header">
    <mat-panel-title>
      2. Ficha do Protocolo
    </mat-panel-title>
  </mat-expansion-panel-header>

  <mat-progress-bar *ngIf="loadCNPJs" class="progress-bar" mode="indeterminate"></mat-progress-bar>
  <form [formGroup]="cabecalhoFundoFixoForm">
    <div class="container container-input" fxLayout="row" fxLayout.xs="column" fxLayoutGap="0.5%">
      <mat-form-field>
        <input matInput formControlName="frmFXCnpjEmpresa" placeholder="CNPJ DA EMPRESA MRV" [(ngModel)]="cabecalhoProtocolo.cnpjEmpresa" (change)="carregarEmpresaTomador()" required [textMask]="{mask: mask.cnpj}">
        <mat-error *ngIf="formFundoFixo.frmFXCnpjEmpresa.errors && formFundoFixo.frmFXCnpjEmpresa.errors.required">CNPJ inválido
        </mat-error>
      </mat-form-field>

      <mat-form-field>
        <input matInput formControlName="frmNomeFXEmpresa" placeholder="NOME DA EMPRESA MRV" [(ngModel)]="cabecalhoProtocolo.nomeEmpresa">
        <mat-error *ngIf="formFundoFixo.frmNomeFXEmpresa.errors && formFundoFixo.frmNomeFXEmpresa.errors.required">Nome da empresa deve ser preenchido
        </mat-error>
      </mat-form-field>
      <mat-form-field>
        <input formControlName="frmFXFundoFixo" type="text" placeholder="FUNDO FIXO" aria-label="Number" matInput [formControl]="frmFXFundoFixo" [matAutocomplete]="autoFundoFixo" [(ngModel)]="valFundoFixo" required>
        <mat-autocomplete #autoFundoFixo="matAutocomplete">
          <mat-option *ngFor="let option of filteredOptionsFundoFixo | async" [value]="option">
            {{option}}
          </mat-option>
        </mat-autocomplete>
        <mat-error *ngIf="formFundoFixo.frmFXFundoFixo.errors && formFundoFixo.frmFXFundoFixo.errors.required">Um aprovador deve ser selecionado</mat-error>
        <mat-hint *ngIf="carregandoFundoFixo">Carregando fundo fixo, aguarde finalizar <img alt="Imagem load" src="assets/images/load32.gif" /></mat-hint>
      </mat-form-field>
    </div>
    <div class="container container-input" fxLayout="row" fxLayout.xs="column" fxLayoutGap="0.5%">
      <mat-form-field fxFlex="33%">
        <input formControlName="frmFXAprovador" type="text" placeholder="APROVADOR" aria-label="Number" matInput [formControl]="frmFXAprovador" [(ngModel)]="cabecalhoProtocolo.aprovador" [(value)]="cabecalhoProtocolo.aprovador" [matAutocomplete]="autoAprovador"
          required>
        <mat-autocomplete #autoAprovador="matAutocomplete">
          <mat-option *ngFor="let option of filteredOptionsAprovador | async" [value]="option">
            {{option}}
          </mat-option>
        </mat-autocomplete>
        <mat-error *ngIf="formFundoFixo.frmFXAprovador.errors && formFundoFixo.frmFXAprovador.errors.required">Um aprovador deve ser selecionado</mat-error>
        <mat-hint *ngIf="carregandoAprovador">Carregando aprovadores, aguarde finalizar <img alt="Imagem load" src="assets/images/load32.gif" /></mat-hint>
      </mat-form-field>
    </div>
    <mat-action-row class="footer">
      <button mat-button color="warn" (click)="prevStepProtocolo()">Voltar</button>
      <button mat-button color="primary" class="btn-primary" (click)="nextStep()">CONTINUAR</button>
    </mat-action-row>

  </form>
</mat-expansion-panel>

<mat-expansion-panel class="expansion-panel" [expanded]="step === 2" (opened)="setStep(2)">
  <mat-expansion-panel-header class="expansionTop-panel">

    <mat-panel-title>
      3. Rateio de Despesas
    </mat-panel-title>
  </mat-expansion-panel-header>

  <mat-progress-bar *ngIf="verifingColetor" class="progress-bar" mode="indeterminate"></mat-progress-bar>
  <form [formGroup]="rateioDespesasFundoFixoForm">
    <div class="container container-input" fxLayout="row" fxLayout.xs="column" fxLayoutGap="0.5%">
      <mat-form-field fxFlex="25%">
        <mat-select formControlName="frmFXTipoDespesa" [(value)]="tiposDespesaSelected" placeholder="Tipo de despesas" required>
          <mat-option *ngFor="let dfundoFixo of despesasfundoFixo" [value]="dfundoFixo">
            {{dfundoFixo.numTransacao}} - {{dfundoFixo.nomeTransacao}}
          </mat-option>
        </mat-select>
        <mat-error *ngIf="formFundoFixoRateio.frmFXTipoDespesa.errors && formFundoFixoRateio.frmFXTipoDespesa.errors.required">Um tipo de despesa deve ser selecionado</mat-error>
      </mat-form-field>
      <mat-form-field fxFlex="25%">
        <mat-select formControlName="frmFXTipoColetor" id="codTipoColetor" [(value)]="rateioDespesas.codTipoColetor" (selectionChange)="validarNumOperacao()" [(ngModel)]="rateioDespesas.codTipoColetor" placeholder="Tipo de coletor">
          <mat-option value="N">N - Diagrama de rede</mat-option>
          <mat-option value="K">K - Centro de custo</mat-option>
          <mat-option value="F">F - Ordem Interna</mat-option>
          <mat-option value="A">A - Imobilizado</mat-option>
          <mat-option value="F">F - Ordem de Manutenção</mat-option>
        </mat-select>
        <mat-error *ngIf="formFundoFixoRateio.frmFXTipoColetor.errors && formFundoFixoRateio.frmFXTipoColetor.errors.required">Um tipo de coletor deve ser selecionado</mat-error>
      </mat-form-field>
      <mat-form-field fxFlex="23%">
        <input matInput formControlName="frmFXColetorCustos" [(ngModel)]="rateioDespesas.identificacaoColetor" value="{{rateioDespesas.identificacaoColetor}}" placeholder="Coletor de Custos">
        <mat-error *ngIf="formFundoFixoRateio.frmFXColetorCustos.errors && formFundoFixoRateio.frmFXColetorCustos.errors.required">Coletor de custos obrigatorio</mat-error>
      </mat-form-field>
      <div fxFlex="4%">
        <a class="linkPesquisa" mat-mini-fab (click)="PesquisarColetorCustos()" *ngIf="PesColetorCustos">
          <mat-icon class="iconPesquisa">search</mat-icon>
        </a>
      </div>
      <mat-form-field fxFlex="23%">
        <input matInput formControlName="frmFXNumOperacao" [(ngModel)]="rateioDespesas.operacaoSubNumero" value="{{rateioDespesas.operacaoSubNumero}}" placeholder="N. da operação" maxlength="4">
        <mat-error *ngIf="formFundoFixoRateio.frmFXNumOperacao.hasError('maxlength') || diagramaDeRede">{{getErrorMessageNumOperacao()}}</mat-error>
      </mat-form-field>
    </div>
    <div class="container container-input" fxLayout="row" fxLayout.xs="column" fxLayoutGap="0.5%">
      <mat-form-field fxFlex="25%">
        <input matInput formControlName="frmFXValorDespesa" [(ngModel)]="rateioDespesas.valor" placeholder="Valor" class="example-right-align" currencyMask [options]="{ prefix: 'R$ ', thousands: '.', decimal: ',' }">
        <mat-error *ngIf="formFundoFixoRateio.frmFXValorDespesa.errors && formFundoFixoRateio.frmFXValorDespesa.errors.required">É necessario um valor
        </mat-error>
      </mat-form-field>
      <mat-form-field fxFlex="65%">
        <input matInput formControlName="frmFXDescricaoDespesa" [(ngModel)]="rateioDespesas.descricao" value="{{rateioDespesas.descricao}}" placeholder="Descrição">
        <mat-error *ngIf="formFundoFixoRateio.frmFXDescricaoDespesa.errors && formFundoFixoRateio.frmFXDescricaoDespesa.errors.required">A descrição é obrigatório</mat-error>
      </mat-form-field>
      <div fxFlex="15%">
        <button mat-button color="primary" style="float: right;margin-top: 5px;" class="btn-primary" (click)="incluirRateio()">INCLUIR</button>
      </div>
    </div>
    <app-planilha-fundo-fixo></app-planilha-fundo-fixo>
    <br />
    <div class="container container-input" fxLayout="row" fxLayout.xs="column" fxLayoutGap="0.5%">
      <div style="padding: 0px !important;">
        <div>
          <mat-form-field>
            <input matInput (keyup)="applyFilter($event.target.value)" placeholder="Filtrar">
          </mat-form-field>
        </div>
        <div class="table-container">
          <table mat-table [dataSource]="dataSource">


            <!-- tipoDespesa Column -->
            <ng-container matColumnDef="tipoDespesa">
              <th mat-header-cell *matHeaderCellDef> Tipo de despesas </th>
              <td mat-cell *matCellDef="let element"> {{element.nomeTipoDespesa}} </td>
            </ng-container>

            <!-- tipoColetor Column -->
            <ng-container matColumnDef="tipoColetor">
              <th mat-header-cell *matHeaderCellDef> Tipo de coletor </th>
              <td mat-cell *matCellDef="let element"> {{element.codTipoColetor}} </td>
            </ng-container>

            <!-- coletorCusto Column -->
            <ng-container matColumnDef="coletorCusto">
              <th mat-header-cell *matHeaderCellDef> Coletor de Custo </th>
              <td mat-cell *matCellDef="let element"> {{element.identificacaoColetor}} </td>
            </ng-container>

            <!-- numeroOperacao Column -->
            <ng-container matColumnDef="numeroOperacao">
              <th mat-header-cell *matHeaderCellDef> Nº da Operação </th>
              <td mat-cell *matCellDef="let element"> {{ element.operacaoSubNumero }}</td>
            </ng-container>

            <!-- descricao Column -->
            <ng-container matColumnDef="descricao">
              <th mat-header-cell *matHeaderCellDef> Descrição </th>
              <td mat-cell *matCellDef="let element"> {{element.descricao}} </td>
            </ng-container>

            <!-- valor Column -->
            <ng-container matColumnDef="valor">
              <th mat-header-cell *matHeaderCellDef> Valor </th>
              <td mat-cell *matCellDef="let element"> {{element.valor | currency:'BRL':true:'1.2-4'}} </td>
            </ng-container>

            <!-- Checkbox Column -->
            <ng-container matColumnDef="select">
              <th mat-header-cell *matHeaderCellDef>
                <mat-icon class="calendar" (click)="deleteAllRows()">delete</mat-icon>
              </th>
              <td mat-cell *matCellDef="let row">
                <mat-icon class="calendar" (click)="deleteRow(row)">delete</mat-icon>
              </td>
            </ng-container>

            <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
            <tr mat-row *matRowDef="let row; columns: displayedColumns;"></tr>
          </table>
        </div>
        <mat-paginator [pageSizeOptions]="[5, 50, 100, 500, 1000]" showFirstLastButtons></mat-paginator>
      </div>
    </div>
    <br />

    <div class="container container-input md-button-right" fxLayout="row" fxLayout.xs="column" fxLayoutGap="0.5%">
      <div fxFlex="70%" style="padding-right: 70px">
        <label class="align-rigth label colored-gray" style="width:250px !important;">A SEREM RATEADOS (R$):
           {{+valorRateio - +somaRateio | currency:'BRL':true:'1.2-4'}}</label>
      </div>
      <div fxFlex="30%">
        <label style="font-weight: 500;" class="align-rigth colored-gray">TOTAL RATEADO (R$): {{somaRateio | currency:'BRL':true:'1.2-4'}}</label>
      </div>
    </div>

    <mat-action-row class="footer">
      <button mat-stroked-button *ngIf="modoEdicao" color="warn" class="cancel-button" (click)="CancelarProtocolo()">CANCELAR PROTOCOLO</button>
      <button (click)="rateioDespesasFundoFixoForm.reset()" class="visible-none" #resetButton type="reset">Reset</button>

      <button mat-button color="warn" (click)="prevStep()">Voltar</button>
      <button mat-button color="primary" class="btn-primary extra-large" (click)="Salvar()">SALVAR PROTOCOLO</button>
    </mat-action-row>
  </form>
</mat-expansion-panel>